<template>
    <Tooltip v-if="!props.hidden" :text="props.tooltipText"  :position="props.tooltipPosition" >
        <div class="cursor-pointer menu-list-item max-w-[40px] h-[40px]" 
            :class="[props.theme, 
            {'bg-gradient-to-r from-blue-500 to-purple-500 !text-white border-none': props.active}]" 
            @click="menuClick()">
            <slot></slot>
        </div>
    </Tooltip>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue'
import Tooltip from '@/components/common/elements/TriadTooltip.vue';

const emit = defineEmits(['menuClick'])
const props = defineProps( {
    disabled: {
        type: Boolean,
        default: true
    },
    hidden: {
        type: Boolean,
        default: true
    },
    tooltipPosition: {
        type: String,
        default: 'top',
        validator: (value) => {
            return ['top', 'bottom', 'left', 'right'].includes(value);
        }
    },
    active: {
        type: Boolean,
        default: false
    },
    theme: {
        type: String,
        default: 'light',
        validator: (value) => {
            return ['light', 'dark'].includes(value);
        }
    },
    tooltipText: {
        type: String,
        default: ''
    }
})

const menuClick = () => {
    emit('menuClick');
}
</script>